import React, { useState } from 'react';
import Icon from '@components/AppIcon';
import Button from '@components/ui/Button';

const LocationsMap = () => {
  const [selectedLocation, setSelectedLocation] = useState(0);

  const locations = [
    {
      id: 1,
      name: "Eye&U Kenya - Westlands Branch",
      address: "3rd Floor, Pacis Centre, Waiyaki Way, Westlands, Nairobi",
      phone: "+254 718 202 020",
      email: "info@eyenu.com",
      hours: {
        weekdays: "Monday - Friday: 8:30 AM - 5:00 PM",
        saturday: "Saturday: 8:30 AM - 1:00 PM",
        sunday: "Sunday: Closed"
      },
      services: ["General Eye Care", "LASIK Surgery", "Cataract Surgery", "Emergency Care"],
      parking: "Free parking available",
      publicTransport: "Accessible via Matatu routes 46, 100, 111",
      lat: -1.261478,
      lng: 36.79166,
      isMain: true
    },
    /*
    {
      id: 2,
      name: "Eye&U Kenya - Eastleigh Branch",
      address: "Minhaj Towers, Ground Floor, Suite No. 08, Nairobi",
      phone: "+254 745 202 020",
      email: "info@eyenu.com",
      hours: {
        weekdays: "Monday - Friday: 9:30 AM - 5:30 PM",
        saturday: "Saturday: 10:00 AM - 3:00 PM",
        sunday: "Sunday: Closed"
      },
      services: ["General Eye Care", "Pediatric Eye Care", "Contact Lens Fitting"],
      parking: "Paid parking in building",
      publicTransport: "Near Westlands Matatu stage",
      lat: -1.2676,
      lng: 36.8108,
      isMain: false
    },
    */
    {
      id: 3,
      name: "Eye&U Kenya - Nakuru Branch",
      address: "Ground Floor, Assumption Centre, Moi Road, Nakuru",
      phone: "+254 110 098 600",
      email: "eyenunku@gmail.com",
      hours: {
        weekdays: "Monday - Friday: 8:30 AM - 5:00 PM",
        saturday: "Saturday: 8:30 AM - 1:00 PM",
        sunday: "Sunday: Closed"
      },
      services: ["General Eye Care", "Diabetic Eye Care", "Glaucoma Treatment"],
      parking: "Free parking available",
      publicTransport: "Accessible via Nakuru Branch-CBD Matatu route",
      lat: -1.3197,
      lng: 36.7078,
      isMain: false
    }
  ];

  const currentLocation = locations[selectedLocation];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 lg:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading font-bold text-3xl lg:text-4xl text-text-primary mb-4" style={{ color: "#08005f" }}>
            Visit Our Locations
          </h2>
          <p className="text-lg text-text-secondary max-w-2xl mx-auto">
            Find the Eye&U Kenya clinic nearest to you. All locations offer comprehensive 
            eye care services with experienced specialists.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          {/* Location Selector */}
          <div className="lg:col-span-1">
            <h3 className="font-heading font-bold text-xl text-text-primary mb-6" style={{ color: "#08005f" }}>
              Our Locations
            </h3>
            
            <div className="space-y-4">
              {locations.map((location, index) => (
                <div
                  key={location.id}
                  className={`p-4 rounded-lg border cursor-pointer medical-transition ${
                    selectedLocation === index
                      ? 'border-primary bg-primary/5' :'border-border hover:border-primary/50'
                  }`}
                  onClick={() => setSelectedLocation(index)}
                >
                  <div className="flex items-start justify-between">
                    <div className="flex-1">
                      <div className="flex items-center space-x-2 mb-2">
                        <h4 className="font-heading font-bold text-text-primary">
                          {location.name.replace('Eye&U Kenya - ', '')}
                        </h4>
                        {location.isMain && (
                          <span className="bg-primary text-white text-xs px-2 py-1 rounded-full">
                            Main
                          </span>
                        )}
                      </div>
                      <p className="text-sm text-text-secondary mb-2">
                        {location.address}
                      </p>
                      <div className="flex items-center space-x-2 text-sm text-text-secondary">
                        <Icon name="Phone" size={14} />
                        <span>{location.phone}</span>
                      </div>
                    </div>
                    <Icon 
                      name="ChevronRight" 
                      size={20} 
                      className={`text-text-secondary medical-transition ${
                        selectedLocation === index ? 'text-primary' : ''
                      }`} 
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Map and Location Details */}
          <div className="lg:col-span-2">
            {/* Interactive Map */}
            <div className="bg-muted rounded-lg overflow-hidden mb-6" style={{ height: '400px' }}>
              <iframe
                width="100%"
                height="100%"
                loading="lazy"
                title={currentLocation.name}
                referrerPolicy="no-referrer-when-downgrade"
                src={`https://www.google.com/maps?q=${currentLocation.lat},${currentLocation.lng}&z=15&output=embed`}
                className="border-0"
              />
            </div>

            {/* Location Details */}
            <div className="bg-white rounded-lg medical-border p-6">
              <div className="flex items-start justify-between mb-6">
                <div>
                  <h3 className="font-heading font-bold text-2xl text-text-primary mb-2">
                    {currentLocation.name}
                  </h3>
                  <p className="text-text-secondary flex items-center space-x-2">
                    <Icon name="MapPin" size={16} />
                    <span>{currentLocation.address}</span>
                  </p>
                </div>
                <Button
                  variant="outline"
                  size="sm"
                  iconName="Navigation"
                  iconPosition="left"
                  onClick={() => window.open(`https://maps.google.com?q=${currentLocation.lat},${currentLocation.lng}`, '_blank')}
                >
                  Get Directions
                </Button>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* Contact Information */}
                <div>
                  <h4 className="font-heading font-bold text-lg text-text-primary mb-4">
                    Contact Information
                  </h4>
                  <div className="space-y-3">
                    <div className="flex items-center space-x-3">
                      <Icon name="Phone" size={18} className="text-primary" />
                      <div>
                        <p className="font-medium text-text-primary">{currentLocation.phone}</p>
                        <p className="text-sm text-text-secondary">Main line</p>
                      </div>
                    </div>
                    <div className="flex items-center space-x-3">
                      <Icon name="Mail" size={18} className="text-primary" />
                      <div>
                        <p className="font-medium text-text-primary">{currentLocation.email}</p>
                        <p className="text-sm text-text-secondary">Email inquiries</p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Operating Hours */}
                <div>
                  <h4 className="font-heading font-bold text-lg text-text-primary mb-4">
                    Operating Hours
                  </h4>
                  <div className="space-y-2">
                    <div className="flex items-center space-x-2">
                      <Icon name="Clock" size={16} className="text-primary" />
                      <span className="text-sm text-text-primary">{currentLocation.hours.weekdays}</span>
                    </div>
                    <div className="flex items-center space-x-2">
                      <Icon name="Clock" size={16} className="text-primary" />
                      <span className="text-sm text-text-primary">{currentLocation.hours.saturday}</span>
                    </div>
                    <div className="flex items-center space-x-2">
                      <Icon name="Clock" size={16} className="text-primary" />
                      <span className="text-sm text-text-primary">{currentLocation.hours.sunday}</span>
                    </div>
                  </div>
                </div>

                {/* Services Available */}
                <div>
                  <h4 className="font-heading font-bold text-lg text-text-primary mb-4">
                    Services Available
                  </h4>
                  <div className="flex flex-wrap gap-2">
                    {currentLocation.services.map((service, index) => (
                      <span
                        key={index}
                        className="bg-primary/10 text-primary px-3 py-1 rounded-full text-sm font-medium"
                      >
                        {service}
                      </span>
                    ))}
                  </div>
                </div>

                {/* Transportation */}
                <div>
                  <h4 className="font-heading font-bold text-lg text-text-primary mb-4">
                    Transportation
                  </h4>
                  <div className="space-y-2">
                    <div className="flex items-start space-x-2">
                      <Icon name="Car" size={16} className="text-primary mt-1" />
                      <span className="text-sm text-text-primary">{currentLocation.parking}</span>
                    </div>
                    <div className="flex items-start space-x-2">
                      <Icon name="Bus" size={16} className="text-primary mt-1" />
                      <span className="text-sm text-text-primary">{currentLocation.publicTransport}</span>
                    </div>
                  </div>
                </div>
              </div>

              <div className="mt-6 pt-6 border-t flex flex-col sm:flex-row gap-4">
                <Button
                  variant="default"
                  iconName="Calendar"
                  iconPosition="left"
                  className="flex-1"
                  onClick={() => window.location.href = '/book-appointment-guided-care-journey'}

                >
                  Book Appointment
                </Button>
                <Button
                  variant="outline"
                  iconName="Phone"
                  iconPosition="left"
                  onClick={() => window.location.href = `tel:${currentLocation.phone}`}
                >
                  Call Location
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LocationsMap;